export default __webpack_public_path__ + "static/media/projectIllustration.f7c7c202.png";